module.exports = __webpack_public_path__ + "hinted-Montserrat-Light.dd0c3d4db67a1c171506.ttf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-Light.ttf
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-Light.ttf
// module chunks = 1